// Module
var code = "<meta name=viewport content=\"width=device-width,initial-scale=1\"> ";
// Exports
module.exports = code;